// 注册指令
import Vue from "vue";
Vue.directive('copy', {
    bind: function(el, binding) {
      el.$copy = function() {
        const textarea = document.createElement('textarea');
        textarea.value = binding.value;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('Copy');
        document.body.removeChild(textarea);
      }
      el.addEventListener('click', el.$copy);
    },
    unbind: function(el) {
      el.removeEventListener('click', el.$copy);
    }
  });


// WEBPACK FOOTER //
// ./src/js/copy.js